import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { RequestReleaseTimeParserPipe } from '@core/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { AlternativeRequestModel } from '@core/models';
import { RequestFiltersService } from '@core/services/request/request-filters.service';
import {
  counterpartyIconResolver,
  hexToRgba,
  leaseProductIconResolver,
} from '@core/helpers';
import { SvgIconComponent } from '@common/components/svg-icon/svg-icon.component';

@Component({
  selector: 'x-alternative-requests-widget-mobile-card',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    RouterLink,
    RequestReleaseTimeParserPipe,
    TranslatePipe,
  ],
  templateUrl: './alternative-requests-widget-mobile-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlternativeRequestsWidgetMobileCardComponent {
  private readonly requestFiltersService = inject(RequestFiltersService);

  readonly $request = input.required<AlternativeRequestModel>({
    alias: 'request',
  });
  readonly mobileRequestsListCompactMode =
    this.requestFiltersService.$mobileRequestsListCompactMode;
  protected readonly hexToRgba = hexToRgba;
  protected readonly counterpartyIconResolver = counterpartyIconResolver;
  protected readonly leaseProductIconResolver = leaseProductIconResolver;

  get requestRoute(): string[] {
    return ['/requests', this.$request().requestNumber];
  }
}
